import axios from 'axios'
import qs from 'qs'
import wx from 'weixin-js-sdk'

// 微信分享
// http://hj.vattihome.com/mob

export const wxshare = (config) => {
  let url = window.location.href
  // console.log(url)
  axios.post('https://ca.hj388.cn/houjin/share/handle/ldmjssdk.php', qs.stringify({
    url: url
  })).then(res => {
    //   console.log(res)

    let data = res.data
    if (data.success === 1) {
      wx.config({
        // debug:true,
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'hideAllNonBaseMenuItem',
          'openLocation',
          'getLocation',
          'hideMenuItems'
        ]
      })
      wx.ready(() => {
        // console.log('分享设置成功')
        if (config.qx === 0) { // 默认权限，开放全部
          let d = {
            title: config.title,
            desc: config.desc,
            link: config.url,
            imgUrl: config.imgurl
          }
          wx.onMenuShareAppMessage(d)
          wx.onMenuShareTimeline(d)
          wx.onMenuShareQQ(d)
          wx.updateAppMessageShareData(d)
          wx.updateTimelineShareData(d)
        } else if (config.qx === 1) { // 禁止分享
          wx.hideMenuItems({ menuList: ['menuItem:copyUrl', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:readMode', 'menuItem:share:qq'] })
        } else if (config.qx === 2) { // 禁止全部
          wx.hideAllNonBaseMenuItem()
        }
      })
    } else {
      // console.log('分享授权错误')
    }
  })
}
